module.exports = __webpack_public_path__ + "media/images/flags/1x1/bgr-d0931c8c0c31744197fa36715391e800.svg";